import { render, staticRenderFns } from "./ContentAboutList.vue?vue&type=template&id=9266b50a"
import script from "./ContentAboutList.vue?vue&type=script&lang=js"
export * from "./ContentAboutList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports